import CallSplitIcon from '@material-ui/icons/CallSplit';

import SplitMethodList from './SplitMethodList';
import SplitMethodCreate from './SplitMethodCreate';
import SplitMethodEdit from './SplitMethodEdit';

export default {
  list: SplitMethodList,
  create: SplitMethodCreate,
  edit: SplitMethodEdit,
  icon: CallSplitIcon
};
